import React, { useEffect, useState } from "react";
import TablePaginate from "../../components/TablePaginate";
import AppTitle from "../../controls/AppTitle";
import AppLoading from "../../common/AppLoading";
import { Link, useHistory } from "react-router-dom";
import BreadCrumb from "../../common/AppBreadCrumb";
import apiService from "../../../apis/service/apiService";
import appColors from "../../../config/appColors";
import AppAlert from "../../common/AppAlert";

function ListServicesScreen() {
	const headers = ["Fecha", "Servicio", "Hora Inicio", "Hora Fin", "Precio"];
	const values = ["created", "name", "start_time", "end_time", "price"];
	const buttons = [
		{ onClick: (service) => EditSelectedService(service), style: "btn", iconName: "pen", iconColor: appColors.green_04 },
		{ onClick: (user) => ShowDeleteSelectedService(user), style: "btn", iconName: "trash-alt", iconColor: appColors.red_04 },
	];

	const history = useHistory();
	const [filter, setFilter] = useState("");
	const [paginator, setPaginator] = useState({});
	const [serviceList, setServiceList] = useState([]);
	const [loading, setLoading] = useState(false);

	const GetServices = async (page = 1) => {
		setLoading(true);
		var response = await apiService.getServicesPaginated(page, filter);
		setLoading(false);

		if (response.ok) {
			setPaginator(response.data.paginator);
			setServiceList(response.data.results);
		}
	};

	const EditSelectedService = (service) => {
		history.push({ pathname: "/service/edit", state: service });
	};

	const ShowDeleteSelectedService = (service) => {
		AppAlert.OptionsAlert(
			"Este servicio se eliminará, y ya no estará disponible para el resto de operaciones, y se eliminará toda su información.",
			"Eliminar de todos modos"
		).then((response) => {
			if (response) {
				DeleteService(service.id);
			}
		});
	};

	const DeleteService = async (service_id) => {
		var response = await apiService.deleteService(service_id);

		if (response.ok) {
			AppAlert.SimpleAlert(response.message);
			GetServices();
		}
	};

	useEffect(() => {
		GetServices();
		return () => {};
	}, []);

	return (
		<div className="row">
			<div className="col-10">
				<AppTitle text="Lista de Servicios Registrados:" />
				<BreadCrumb items={[{ label: "Servicios" }, { label: "Lista de Servicios", active: true }]} />
			</div>
			<div className="col-2 d-flex align-items-center">
				<Link className="btn btn-sm btn-success" to={"service/create"}>
					Registrar Servicio
				</Link>
			</div>
			<div className="col-12">
				<TablePaginate
					headers={headers}
					buttons={buttons}
					rows={serviceList}
					values={values}
					onSearchApi={(page) => GetServices(page)}
					onChangeFilter={setFilter}
					paginator={paginator}
				/>
			</div>
			<AppLoading visible={loading} />
		</div>
	);
}

export default ListServicesScreen;
